const FrameExit = () => {
  const eventMessage = {
    event: { name: 'gameClosing' },
  };
  window.parent.postMessage(JSON.stringify(eventMessage), '*');
  return null;
};

export default FrameExit;
